exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav_w2 {\n  width: 100%;\n  height: 0.260417rem;\n}\n.nav_w2 .main {\n  width: 4.270833rem;\n  display: flex;\n  margin: 0 auto;\n  justify-content: space-around;\n}\n.nav_w2 .main .item_2 {\n  height: 0.239583rem;\n  font-size: 0.145833rem;\n  font-weight: 400;\n  color: #fff;\n  line-height: 0.208333rem;\n  cursor: pointer;\n  padding: 0 0.083333rem;\n  word-break: keep-all;\n  white-space: nowrap;\n}\n.nav_w2 .main .active,\n.nav_w2 .main .item_2:active {\n  border-bottom: 0.010417rem solid #fff;\n}", ""]);

// exports
